import {
  component_styles_default
} from "./chunk.YTLQMGH4.js";
import {
  r
} from "./chunk.X63DNLWS.js";

// packages/web-components/src/components/Footer/Footer.styles.ts
var Footer_styles_default = r`
  ${component_styles_default}

  .footer__wrapper {
    padding: var(--myd-footer-spacing-mobile-menu-item-gap-vertical) var(--myd-footer-spacing-mobile-left-right);
    background: var(--myd-footer-color-footer-gradient-mobile);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--myd-footer-spacing-mobile-menu-item-gap-vertical) var(--myd-footer-spacing-mobile-gap);
  }

  @media (min-width: 768px) {
    .footer__wrapper {
      padding: var(--myd-footer-spacing-mobile-menu-item-gap-vertical) var(--myd-footer-spacing-tablet-left-right);
      background: var(--myd-footer-color-footer-background);
    }
  }

  @media (min-width: 1440px) {
    .footer__wrapper {
      padding-left: var(--myd-footer-spacing-item-left-right);
      padding-right: var(--myd-footer-spacing-item-left-right);
      flex-direction: row;
    }
  }

  @media (min-width: 1440px) {
    .footer {
      padding-left: var(--myd-footer-spacing-left-right);
      padding-right: var(--myd-footer-spacing-left-right);
      background: var(--myd-footer-color-footer-background);
    }

    .footer--provider {
      background: var(--myd-footer-color-footer-background-dark);
    }

    .footer__wrapper--provider {
      background: var(--myd-footer-color-footer-background-dark);
    }
  }

  .footer__nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--myd-footer-spacing-mobile-menu-item-gap-vertical) var(--myd-footer-spacing-mobile-gap);
  }

  .footer__nav__item {
    color: var(--myd-footer-color-link-text-default);
    font-family: var(--myd-footer-typography-link-button-mobile-font-family);
    font-weight: var(--myd-footer-typography-link-button-mobile-font-weight);
    line-height: var(--myd-footer-typography-link-button-mobile-line-height);
    font-size: var(--myd-footer-typography-link-button-mobile-font-size);
    letter-spacing: var(--myd-footer-typography-link-button-mobile-letter-spacing);
    text-decoration: var(--myd-footer-typography-link-button-mobile-text-decoration);
    text-wrap: balance;
    text-align: center;
  }

  .footer__nav__item:hover {
    color: var(--myd-footer-color-link-text-hover);
  }

  .footer__policies {
    color: var(--myd-footer-color-copyright);
    font-family: var(--myd-footer-typography-copyright-font-family);
    font-weight: var(--myd-footer-typography-copyright-font-weight);
    line-height: var(--myd-footer-typography-copyright-line-height);
    font-size: var(--myd-footer-typography-copyright-font-size);
    letter-spacing: var(--myd-footer-typography-copyright-letter-spacing);
    text-decoration: var(--myd-footer-typography-copyright-text-decoration);
  }

  .footer__policies:first-of-type {
    display: none;
  }

  .footer__policies:last-of-type {
    display: block;
  }

  @media (min-width: 1440px) {
    .footer__policies {
      flex: 1;
      text-wrap: balance;
    }

    .footer__policies:first-of-type {
      display: block;
    }

    .footer__policies:last-of-type {
      display: none;
    }
  }

  /* Provider desktop dark theme */
  @media (min-width: 1440px) {
    .footer__nav__item--provider {
      color: var(--myd-footer-color-link-text-default-dark);
    }

    .footer__nav__item--provider:hover {
      color: var(--myd-footer-color-link-text-hover-dark);
    }

    .footer__policies--provider {
      color: var(--myd-footer-color-copyright-dark);
    }
  }

  .footer__policies__link {
    color: var(--myd-footer-color-copyright-link);
    text-decoration: var(--myd-footer-typography-copyright-text-decoration);
  }

  .footer__trademark {
    display: none;
  }

  .footer__trademark--patient {
    display: block;
  }

  .footer__trademark--provider {
    display: block;
  }
`;

export {
  Footer_styles_default
};
